import axios from "axios";
import jwt from "jsonwebtoken";
const token = localStorage.getItem("user_token");
const user = jwt.decode(token);
//Lc Screen

const createNewLC = async (
  // formState,
  // setFormState,
  // setErrorMessage,
  // setSuccessMessage,
  // navigate,
  // setOpenProceedBtn,
  // setPost

  formState,
  setFormState,
  setErrorMessage,
  setSuccessMessage,
  setOpenProceedBtn
) => {
  const stringifiedData = JSON.stringify(formState);
  const data = JSON.parse(stringifiedData);
  await axios({
    // method: `${
    //   formState?.lc_id === 0 || formState?.lc_id === "" ? "Post" : "Put"
    // }`,

    method: "Post",

    url: `${process.env.REACT_APP_API_URL}/api/VendorFinancing/AddVendorFinancing`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  })
    .then(async (res) => {
      if (res.status === 200) {
        setOpenProceedBtn(false);
        // setPost(false);
        setErrorMessage("");
        setSuccessMessage("Your LC has been created Successfully");
      }
    })
    .catch((err) => {
      if (err?.response?.data) {
        setErrorMessage(err?.response?.data?.title || err?.response?.data);
      } else {
        setErrorMessage(err?.message);
      }

      setOpenProceedBtn(false);
      // setPost(false);
    });
};

const getBankDetail = async (user, setUserData, setLoading) => {
  setLoading(true);
  //
  await axios({
    method: "get", //you can set what request you want to be
    url: `${process.env.REACT_APP_API_URL}/api/VendorFinancing/GetBankDetails`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
  })
    .then(async (res) => {
      setUserData(res.data);
      setLoading(false);
    })
    .catch((err) => {
      setLoading(false);

      // setErrorMessage("Invalid username or password");
    });
};

const getLcsLandingPage = async (
  setLcs,
  setLcsLoading,
  formState,
  setCount
) => {
  const vendorCode = formState?.Vendor?.Vendor_Code;
  console.log(formState , "formstate")
  setLcsLoading(true)

  await axios({
    method: "get",
    url: `${process.env.REACT_APP_API_URL}/api/VendorFinancing/${
      vendorCode !== "-1"
        ? `GetLCbyVendorCode/${vendorCode}?pageNumber=${
            formState?.PageNo
          }&pageSize=${formState?.RowsOfPage}${formState?.isAsc ? `&isAsc=${formState?.isAsc}` : `&isAsc=${true}`}${
            formState?.Generic ? `&searchQuery=${formState?.Generic}` : ""
          }`
        : `GetAllLCs?pageNumber=${formState?.PageNo}&pageSize=${
            formState?.RowsOfPage
          }&isAsc=${formState?.isAsc}${formState?.Generic ? `&searchQuery=${formState?.Generic}` : ""}`
    }`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
  })
  
    .then(async (res) => {
      setLcs(res.data?.data);
      setCount(res?.data?.totalRecords);
      setLcsLoading(false);
    })
    .catch((err) => {
      setLcsLoading(false);
    });
};

const getBatchbyLCId = async (
  lcId, 
  setBatch
) => {

  console.log("lc id")
  await axios({
    method: "get", //you can set what request you want to be
    url: `${process.env.REACT_APP_API_URL}/api/VendorFinancing/GetBatchByLCID/${lcId}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
  })
    .then(async (res) => {
      setBatch(res.data)

      console.log(res, "ress")
      // setUserData(res.data);
      // setLoading(false);
    })
    .catch((err) => {
      // setLoading(false);

      // setErrorMessage("Invalid username or password");
    });
}

// GetLCbyVendorCode
export { createNewLC, getBankDetail, getLcsLandingPage , getBatchbyLCId };
